import '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, useEffect, createElement, Fragment } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../Spinner/Spinner.js';
import '../utils-fabc7ae7.js';
import 'react-dom';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import 'element-resize-detector';
import '../ContainerDimensions/ContainerDimensions.js';
import 'react-grid-layout';
import DashboardBase from './DashboardBase.js';
import DashboardContextProvider from './DashboardContext.js';
import useDashboard from './use-dashboard.js';

const _excluded = ["showUndoButton"],
  _excluded2 = ["widgets"];
function InnerEditableDashboard(_ref) {
  let {
      showUndoButton = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [state, dispatch] = useDashboard();
  const {
    deletedWidgets
  } = state;
  const onUndoClicked = () => deletedWidgets && deletedWidgets.length && dispatch({
    type: 'UNDO_REMOVE_LAYOUT'
  });
  return /*#__PURE__*/createElement(Fragment, null, showUndoButton && /*#__PURE__*/createElement(Button, {
    iconOnly: true,
    iconProps: {
      glyph: icons.UNDO
    },
    onClick: onUndoClicked
  }), /*#__PURE__*/createElement(DashboardBase, props));
}
function DashboardEditable(_ref2) {
  let {
      widgets
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const [editableWidgets, setEditableWidgets] = useState(null);
  useEffect(() => {
    const updatedWidgets = widgets.map(widget => {
      widget.layout = _objectSpread2(_objectSpread2({}, widget.layout), {}, {
        static: widget.layout.static !== null && widget.layout.static !== undefined ? widget.layout.static : false,
        isResizable: widget.layout.isResizable !== null && widget.layout.isResizable !== undefined ? widget.layout.isResizable : true
      });
      widget.removable = widget.removable !== null && widget.removable !== undefined ? widget.removable : true;
      widget.lockable = widget.lockable !== null && widget.lockable !== undefined ? widget.lockable : true;
      return widget;
    });
    setEditableWidgets(updatedWidgets);
  }, [widgets]);
  return /*#__PURE__*/createElement(DashboardContextProvider, null, /*#__PURE__*/createElement(InnerEditableDashboard, _extends({
    widgets: editableWidgets
  }, rest)));
}

export default DashboardEditable;
